import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { UnusedSinceDurationCellRenderer } from "../column-def-cell-renderers/unused-since/UnusedSinceDurationCellRenderer";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { unusedSinceDurationValueGetter } from "../../../utils/value-getters/unusedSinceDurationValueGetter";
import {
  FilteredAzLbResourceItem,
  UnusedSince,
} from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const azLbColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("LB Name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_lb"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  {
    field: "resource.resource_group",
    headerName: "Resource Group",
  },

  resourceCreatedByColumnDef,

  {
    field: "resource.unused_since",
    headerName: "No Traffic Since",
    valueGetter: unusedSinceDurationValueGetter,
    cellRenderer: ({ data }: ICellRendererParams<FilteredAzLbResourceItem>) => {
      if (!data) {
        return null;
      }

      const unusedSince = data?.resource?.unused_since as UnusedSince;

      return <UnusedSinceDurationCellRenderer data={unusedSince} />;
    },
  },

  { field: "resource.sku", headerName: "SKU" },
  {
    field: "resource.has_backend",
    headerName: "Backends Empty",
    headerTooltip:
      "Backends Empty: YES - indicates that the load balancer has no running backend resources.",
    cellRenderer: ({ data }: ICellRendererParams<FilteredAzLbResourceItem>) => {
      return (
        <Typography variant="body2">
          {!data?.resource?.has_backend ? "Yes" : "No"}
        </Typography>
      );
    },
  },
  { field: "resource.number_of_rules", headerName: "Rules" },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
